import { ActionButton } from "@hamlak/ui";
import { platform } from "@/platform";
import { t } from "@/i18n/ko";
import { useUiStore } from "@/stores/uiStore";

/** Android 인앱 브라우저에서 Chrome으로 같은 URL을 연다(auth-session 4.5). */
export function externalBrowserUrl(href: string): string {
  const u = new URL(href);
  return `intent://${u.host}${u.pathname}${u.search}#Intent;scheme=https;package=com.android.chrome;end`;
}

const isIos = (ua: string) => /iPhone|iPad|iPod/i.test(ua);

/**
 * 인앱 브라우저(카카오톡·인스타그램 등) 안내 본문 + 버튼. 로그인 시트·OpenInBrowserPage 공용.
 * Android: intent://로 Chrome. iOS: 현재 URL 복사 + Safari 안내 토스트.
 */
export function OpenInBrowserNotice({ href = typeof window !== "undefined" ? window.location.href : "" }: { href?: string }) {
  const showSnackbar = useUiStore((s) => s.showSnackbar);
  const ios = typeof navigator !== "undefined" && isIos(navigator.userAgent);

  const open = async () => {
    if (ios) {
      try {
        await platform.device.copy(href);
        showSnackbar(t("login.openInBrowser.copied"));
      } catch {
        showSnackbar(t("error.generic"));
      }
      return;
    }
    window.location.assign(externalBrowserUrl(href));
  };

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
      <p style={{ margin: 0 }}>{t("login.openInBrowser")}</p>
      <ActionButton variant="brandSolid" size="large" block onClick={() => void open()}>
        {t("login.openInBrowser.cta")}
      </ActionButton>
    </div>
  );
}
